export const RoutesData = {
    Home: "/",
    Start: "/start"
}